import { APIURL } from "./config";

export async function submitReview(submissionData: any, token: string) {
  const response = await fetch(`${APIURL}/Assignments/review`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(submissionData),
  });

  if (!response.ok) {
    throw new Error("Failed to submit assignment");
  }
}

export async function fetchComments(candidateId: string, roleId: string, token: string) {
  try {
    const response = await fetch(
      `${APIURL}/Assignments/GetReview?candidateId=${candidateId}&roleId=${roleId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch comments");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`Failed to fetch comments:`);
  }
}

export async function GetCandidateData(email: string, roleId: string, token: string) {
  try {
    const response = await fetch(
      `${APIURL}/Assignments/candidateData?email=${encodeURIComponent(email)}&roleId=${roleId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to check assignment submission");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}


export async function GetAssignmentData(token: string) {
  try {
    const response = await fetch(`${APIURL}/Assignments/Getdata`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to load data: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Failed to load data: ${error}`);
    throw new Error(`Failed to load data`);
  }
}

export const GetAssignmentDataByRole = async (
  roleId: string,
  pageNumber: number = 1,
  searchQuery: string = "",
  pageSize: number = 20,
  endDate?: string,
  token: string = ""
) => {
  try {
    const url = new URL(`${APIURL}/Assignments/role/${roleId}`);
    url.searchParams.append("pageNumber", String(pageNumber));
    if (searchQuery) url.searchParams.append("searchQuery", searchQuery);
    url.searchParams.append("pageSize", String(pageSize));
    if (endDate) url.searchParams.append("endDate", endDate);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching assignment data by role:', error);
    throw error;
  }
};

export const ReviewAssignment = async (
  candidateId: string,
  roleId: string,
  isReviewed: boolean,
  token: string
) => {
  try {
    const response = await fetch(`${APIURL}/Assignments/review/${roleId}/${candidateId}?isReviewed=${isReviewed}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error submitting assignment grade:', error);
    throw error;
  }
};
